import getConfig from 'next/config';
export const isProdBuild = process.env.NODE_ENV === 'production';
export const isDevBuild = process.env.NODE_ENV === 'development';

export const isProduction = process.env.ENV === 'production';
export const isStage = process.env.ENV === 'stage';

export const getIsStage = () => getConfig().publicRuntimeConfig.environment === 'stage';
